var be = Object.defineProperty;
var me = (r, t, e) => t in r ? be(r, t, { enumerable: !0, configurable: !0, writable: !0, value: e }) : r[t] = e;
var h = (r, t, e) => (me(r, typeof t != "symbol" ? t + "" : t, e), e);
class ne {
  /**
   * @param client The client used to retrieve the entity data
   */
  constructor(t) {
    h(this, "list");
    this.client = t, this.list = t.list;
  }
}
class bt extends ne {
  /**
   * @param client The client used to retrieve the entity data
   */
  constructor(e) {
    super(e);
    h(this, "get");
    this.client = e, this.get = e.get;
  }
}
class mt extends Error {
  constructor(e, n) {
    super(e.message, n);
    h(this, "code");
    h(this, "data");
    this.name = this.constructor.name, this.code = e.code, this.data = e.data, Error.captureStackTrace(this, this.constructor);
  }
}
function g(r) {
  const t = typeof r;
  return r == null ? String(r) : t === "function" ? "" : r instanceof RegExp ? r.toString() : r instanceof Date ? r.toISOString() : Array.isArray(r) ? "[" + r.map(g).join(",") + "]" : t === "object" ? "{" + Object.entries(r).filter(([, e]) => e != null && typeof e != "function").sort((e, n) => e[0].localeCompare(n[0])).map(([e, n]) => `${e}:${g(n)}`).join(",") + "}" : String(r);
}
var vt;
class ie {
  /**
   * @param hashMethod The custom hash method
   */
  constructor(t) {
    h(this, vt, "CustomHashMap");
    h(this, "map", /* @__PURE__ */ new Map());
    this.hashMethod = t;
  }
  /**
   * @inheritDoc {@link Map#has}
   */
  has(t) {
    return this.map.has(this.hashMethod(t));
  }
  /**
   * @inheritDoc {@link Map#get}
   */
  get(t) {
    const e = this.map.get(this.hashMethod(t));
    return e ? e[1] : void 0;
  }
  /**
   * @inheritDoc {@link Map#set}
   */
  set(t, e) {
    return this.map.set(this.hashMethod(t), [t, e]), this;
  }
  /**
   * @inheritDoc {@link Map#delete}
   */
  delete(t) {
    return this.map.delete(this.hashMethod(t));
  }
  /**
   * @inheritDoc {@link Map#size}
   */
  get size() {
    return this.map.size;
  }
  /**
   * @inheritDoc {@link Map#clear}
   */
  clear() {
    this.map.clear();
  }
  /**
   * @inheritDoc {@link Map#entries}
   */
  entries() {
    return this.map.values();
  }
  /**
   * @inheritDoc {@link Map#forEach}
   */
  // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
  forEach(t, e) {
    Array.from(this.map.values()).forEach(([n, i]) => {
      t.call(e, i, n, this);
    });
  }
  /**
   * @inheritDoc {@link Map#keys}
   */
  keys() {
    return Array.from(this.map.values()).map(([t]) => t).values();
  }
  /**
   * @inheritDoc {@link Map#values}
   */
  values() {
    return Array.from(this.map.values()).map(([, t]) => t).values();
  }
  /**
   * Converts this {@link CustomHashMap} into a standard {@link Map}
   */
  toMap() {
    return new Map(this.map.values());
  }
  [(vt = Symbol.toStringTag, Symbol.iterator)]() {
    return this.map.values();
  }
}
function ge(r, t = g) {
  const e = new ie(t);
  return (...n) => {
    const i = e.get(n);
    if (i != null)
      return i;
    const s = r(...n);
    return e.set(n, s), s;
  };
}
class we {
  /**
   * @param client The client used to retrieve the entity data
   * @param changeEventService The change event service to listen to changes on and to push changes to
   * @param entityType The type of entity the service is responsible for
   * @param toPathParameters Allows the mapping of entities into cache keys
   */
  constructor(t, e, n, i, s = []) {
    h(this, "list");
    this.factory = t, this.entityType = e, this.client = n, this.toPathParameters = i, this.dependencyEntityTypes = s, this.list = t.list(
      e,
      n.list,
      s
    );
  }
}
class Se extends we {
  /**
   * @inheritDoc
   */
  constructor(e, n, i, s, o = []) {
    super(e, n, i, s, o);
    h(this, "get");
    this.get = e.get(
      n,
      i.get,
      o
    );
  }
}
class gt extends Se {
  /**
   * @inheritDoc
   */
  constructor(e, n, i, s, o = []) {
    super(e, n, i, s, o);
    h(this, "create");
    h(this, "update");
    h(this, "delete");
    this.create = e.entityAwaitingMutation(i.create), this.update = e.revisionedEntityAwaitingMutation(i.update), this.delete = e.revisionedEntityAwaitingMutation(i.delete);
  }
}
function d(r) {
  return typeof r == "function";
}
function Ee(r) {
  return d(r == null ? void 0 : r.lift);
}
function q(r) {
  return function(t) {
    if (Ee(t))
      return t.lift(function(e) {
        try {
          return r(e, this);
        } catch (n) {
          this.error(n);
        }
      });
    throw new TypeError("Unable to lift unknown Observable type");
  };
}
var L = function(r, t) {
  return L = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(e, n) {
    e.__proto__ = n;
  } || function(e, n) {
    for (var i in n)
      Object.prototype.hasOwnProperty.call(n, i) && (e[i] = n[i]);
  }, L(r, t);
};
function w(r, t) {
  if (typeof t != "function" && t !== null)
    throw new TypeError("Class extends value " + String(t) + " is not a constructor or null");
  L(r, t);
  function e() {
    this.constructor = r;
  }
  r.prototype = t === null ? Object.create(t) : (e.prototype = t.prototype, new e());
}
function Re(r, t, e, n) {
  function i(s) {
    return s instanceof e ? s : new e(function(o) {
      o(s);
    });
  }
  return new (e || (e = Promise))(function(s, o) {
    function a(l) {
      try {
        c(n.next(l));
      } catch (y) {
        o(y);
      }
    }
    function u(l) {
      try {
        c(n.throw(l));
      } catch (y) {
        o(y);
      }
    }
    function c(l) {
      l.done ? s(l.value) : i(l.value).then(a, u);
    }
    c((n = n.apply(r, t || [])).next());
  });
}
function se(r, t) {
  var e = { label: 0, sent: function() {
    if (s[0] & 1)
      throw s[1];
    return s[1];
  }, trys: [], ops: [] }, n, i, s, o;
  return o = { next: a(0), throw: a(1), return: a(2) }, typeof Symbol == "function" && (o[Symbol.iterator] = function() {
    return this;
  }), o;
  function a(c) {
    return function(l) {
      return u([c, l]);
    };
  }
  function u(c) {
    if (n)
      throw new TypeError("Generator is already executing.");
    for (; o && (o = 0, c[0] && (e = 0)), e; )
      try {
        if (n = 1, i && (s = c[0] & 2 ? i.return : c[0] ? i.throw || ((s = i.return) && s.call(i), 0) : i.next) && !(s = s.call(i, c[1])).done)
          return s;
        switch (i = 0, s && (c = [c[0] & 2, s.value]), c[0]) {
          case 0:
          case 1:
            s = c;
            break;
          case 4:
            return e.label++, { value: c[1], done: !1 };
          case 5:
            e.label++, i = c[1], c = [0];
            continue;
          case 7:
            c = e.ops.pop(), e.trys.pop();
            continue;
          default:
            if (s = e.trys, !(s = s.length > 0 && s[s.length - 1]) && (c[0] === 6 || c[0] === 2)) {
              e = 0;
              continue;
            }
            if (c[0] === 3 && (!s || c[1] > s[0] && c[1] < s[3])) {
              e.label = c[1];
              break;
            }
            if (c[0] === 6 && e.label < s[1]) {
              e.label = s[1], s = c;
              break;
            }
            if (s && e.label < s[2]) {
              e.label = s[2], e.ops.push(c);
              break;
            }
            s[2] && e.ops.pop(), e.trys.pop();
            continue;
        }
        c = t.call(r, e);
      } catch (l) {
        c = [6, l], i = 0;
      } finally {
        n = s = 0;
      }
    if (c[0] & 5)
      throw c[1];
    return { value: c[0] ? c[1] : void 0, done: !0 };
  }
}
function A(r) {
  var t = typeof Symbol == "function" && Symbol.iterator, e = t && r[t], n = 0;
  if (e)
    return e.call(r);
  if (r && typeof r.length == "number")
    return {
      next: function() {
        return r && n >= r.length && (r = void 0), { value: r && r[n++], done: !r };
      }
    };
  throw new TypeError(t ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function I(r, t) {
  var e = typeof Symbol == "function" && r[Symbol.iterator];
  if (!e)
    return r;
  var n = e.call(r), i, s = [], o;
  try {
    for (; (t === void 0 || t-- > 0) && !(i = n.next()).done; )
      s.push(i.value);
  } catch (a) {
    o = { error: a };
  } finally {
    try {
      i && !i.done && (e = n.return) && e.call(n);
    } finally {
      if (o)
        throw o.error;
    }
  }
  return s;
}
function x(r, t, e) {
  if (e || arguments.length === 2)
    for (var n = 0, i = t.length, s; n < i; n++)
      (s || !(n in t)) && (s || (s = Array.prototype.slice.call(t, 0, n)), s[n] = t[n]);
  return r.concat(s || Array.prototype.slice.call(t));
}
function R(r) {
  return this instanceof R ? (this.v = r, this) : new R(r);
}
function Ae(r, t, e) {
  if (!Symbol.asyncIterator)
    throw new TypeError("Symbol.asyncIterator is not defined.");
  var n = e.apply(r, t || []), i, s = [];
  return i = {}, o("next"), o("throw"), o("return"), i[Symbol.asyncIterator] = function() {
    return this;
  }, i;
  function o(f) {
    n[f] && (i[f] = function(v) {
      return new Promise(function(b, p) {
        s.push([f, v, b, p]) > 1 || a(f, v);
      });
    });
  }
  function a(f, v) {
    try {
      u(n[f](v));
    } catch (b) {
      y(s[0][3], b);
    }
  }
  function u(f) {
    f.value instanceof R ? Promise.resolve(f.value.v).then(c, l) : y(s[0][2], f);
  }
  function c(f) {
    a("next", f);
  }
  function l(f) {
    a("throw", f);
  }
  function y(f, v) {
    f(v), s.shift(), s.length && a(s[0][0], s[0][1]);
  }
}
function Ie(r) {
  if (!Symbol.asyncIterator)
    throw new TypeError("Symbol.asyncIterator is not defined.");
  var t = r[Symbol.asyncIterator], e;
  return t ? t.call(r) : (r = typeof A == "function" ? A(r) : r[Symbol.iterator](), e = {}, n("next"), n("throw"), n("return"), e[Symbol.asyncIterator] = function() {
    return this;
  }, e);
  function n(s) {
    e[s] = r[s] && function(o) {
      return new Promise(function(a, u) {
        o = r[s](o), i(a, u, o.done, o.value);
      });
    };
  }
  function i(s, o, a, u) {
    Promise.resolve(u).then(function(c) {
      s({ value: c, done: a });
    }, o);
  }
}
var xe = function(r) {
  return r && typeof r.length == "number" && typeof r != "function";
};
function _e(r) {
  return d(r == null ? void 0 : r.then);
}
function oe(r) {
  var t = function(n) {
    Error.call(n), n.stack = new Error().stack;
  }, e = r(t);
  return e.prototype = Object.create(Error.prototype), e.prototype.constructor = e, e;
}
var j = oe(function(r) {
  return function(e) {
    r(this), this.message = e ? e.length + ` errors occurred during unsubscription:
` + e.map(function(n, i) {
      return i + 1 + ") " + n.toString();
    }).join(`
  `) : "", this.name = "UnsubscriptionError", this.errors = e;
  };
});
function k(r, t) {
  if (r) {
    var e = r.indexOf(t);
    0 <= e && r.splice(e, 1);
  }
}
var P = function() {
  function r(t) {
    this.initialTeardown = t, this.closed = !1, this._parentage = null, this._finalizers = null;
  }
  return r.prototype.unsubscribe = function() {
    var t, e, n, i, s;
    if (!this.closed) {
      this.closed = !0;
      var o = this._parentage;
      if (o)
        if (this._parentage = null, Array.isArray(o))
          try {
            for (var a = A(o), u = a.next(); !u.done; u = a.next()) {
              var c = u.value;
              c.remove(this);
            }
          } catch (p) {
            t = { error: p };
          } finally {
            try {
              u && !u.done && (e = a.return) && e.call(a);
            } finally {
              if (t)
                throw t.error;
            }
          }
        else
          o.remove(this);
      var l = this.initialTeardown;
      if (d(l))
        try {
          l();
        } catch (p) {
          s = p instanceof j ? p.errors : [p];
        }
      var y = this._finalizers;
      if (y) {
        this._finalizers = null;
        try {
          for (var f = A(y), v = f.next(); !v.done; v = f.next()) {
            var b = v.value;
            try {
              W(b);
            } catch (p) {
              s = s ?? [], p instanceof j ? s = x(x([], I(s)), I(p.errors)) : s.push(p);
            }
          }
        } catch (p) {
          n = { error: p };
        } finally {
          try {
            v && !v.done && (i = f.return) && i.call(f);
          } finally {
            if (n)
              throw n.error;
          }
        }
      }
      if (s)
        throw new j(s);
    }
  }, r.prototype.add = function(t) {
    var e;
    if (t && t !== this)
      if (this.closed)
        W(t);
      else {
        if (t instanceof r) {
          if (t.closed || t._hasParent(this))
            return;
          t._addParent(this);
        }
        (this._finalizers = (e = this._finalizers) !== null && e !== void 0 ? e : []).push(t);
      }
  }, r.prototype._hasParent = function(t) {
    var e = this._parentage;
    return e === t || Array.isArray(e) && e.includes(t);
  }, r.prototype._addParent = function(t) {
    var e = this._parentage;
    this._parentage = Array.isArray(e) ? (e.push(t), e) : e ? [e, t] : t;
  }, r.prototype._removeParent = function(t) {
    var e = this._parentage;
    e === t ? this._parentage = null : Array.isArray(e) && k(e, t);
  }, r.prototype.remove = function(t) {
    var e = this._finalizers;
    e && k(e, t), t instanceof r && t._removeParent(this);
  }, r.EMPTY = function() {
    var t = new r();
    return t.closed = !0, t;
  }(), r;
}(), ae = P.EMPTY;
function ue(r) {
  return r instanceof P || r && "closed" in r && d(r.remove) && d(r.add) && d(r.unsubscribe);
}
function W(r) {
  d(r) ? r() : r.unsubscribe();
}
var ce = {
  onUnhandledError: null,
  onStoppedNotification: null,
  Promise: void 0,
  useDeprecatedSynchronousErrorHandling: !1,
  useDeprecatedNextContext: !1
}, U = {
  setTimeout: function(r, t) {
    for (var e = [], n = 2; n < arguments.length; n++)
      e[n - 2] = arguments[n];
    var i = U.delegate;
    return i != null && i.setTimeout ? i.setTimeout.apply(i, x([r, t], I(e))) : setTimeout.apply(void 0, x([r, t], I(e)));
  },
  clearTimeout: function(r) {
    var t = U.delegate;
    return ((t == null ? void 0 : t.clearTimeout) || clearTimeout)(r);
  },
  delegate: void 0
};
function le(r) {
  U.setTimeout(function() {
    throw r;
  });
}
function Q() {
}
function O(r) {
  r();
}
var N = function(r) {
  w(t, r);
  function t(e) {
    var n = r.call(this) || this;
    return n.isStopped = !1, e ? (n.destination = e, ue(e) && e.add(n)) : n.destination = Ce, n;
  }
  return t.create = function(e, n, i) {
    return new H(e, n, i);
  }, t.prototype.next = function(e) {
    this.isStopped || this._next(e);
  }, t.prototype.error = function(e) {
    this.isStopped || (this.isStopped = !0, this._error(e));
  }, t.prototype.complete = function() {
    this.isStopped || (this.isStopped = !0, this._complete());
  }, t.prototype.unsubscribe = function() {
    this.closed || (this.isStopped = !0, r.prototype.unsubscribe.call(this), this.destination = null);
  }, t.prototype._next = function(e) {
    this.destination.next(e);
  }, t.prototype._error = function(e) {
    try {
      this.destination.error(e);
    } finally {
      this.unsubscribe();
    }
  }, t.prototype._complete = function() {
    try {
      this.destination.complete();
    } finally {
      this.unsubscribe();
    }
  }, t;
}(P), Te = Function.prototype.bind;
function $(r, t) {
  return Te.call(r, t);
}
var Pe = function() {
  function r(t) {
    this.partialObserver = t;
  }
  return r.prototype.next = function(t) {
    var e = this.partialObserver;
    if (e.next)
      try {
        e.next(t);
      } catch (n) {
        C(n);
      }
  }, r.prototype.error = function(t) {
    var e = this.partialObserver;
    if (e.error)
      try {
        e.error(t);
      } catch (n) {
        C(n);
      }
    else
      C(t);
  }, r.prototype.complete = function() {
    var t = this.partialObserver;
    if (t.complete)
      try {
        t.complete();
      } catch (e) {
        C(e);
      }
  }, r;
}(), H = function(r) {
  w(t, r);
  function t(e, n, i) {
    var s = r.call(this) || this, o;
    if (d(e) || !e)
      o = {
        next: e ?? void 0,
        error: n ?? void 0,
        complete: i ?? void 0
      };
    else {
      var a;
      s && ce.useDeprecatedNextContext ? (a = Object.create(e), a.unsubscribe = function() {
        return s.unsubscribe();
      }, o = {
        next: e.next && $(e.next, a),
        error: e.error && $(e.error, a),
        complete: e.complete && $(e.complete, a)
      }) : o = e;
    }
    return s.destination = new Pe(o), s;
  }
  return t;
}(N);
function C(r) {
  le(r);
}
function Me(r) {
  throw r;
}
var Ce = {
  closed: !0,
  next: Q,
  error: Me,
  complete: Q
}, Y = function() {
  return typeof Symbol == "function" && Symbol.observable || "@@observable";
}();
function Oe(r) {
  return r;
}
function ke(r) {
  return r.length === 0 ? Oe : r.length === 1 ? r[0] : function(e) {
    return r.reduce(function(n, i) {
      return i(n);
    }, e);
  };
}
var m = function() {
  function r(t) {
    t && (this._subscribe = t);
  }
  return r.prototype.lift = function(t) {
    var e = new r();
    return e.source = this, e.operator = t, e;
  }, r.prototype.subscribe = function(t, e, n) {
    var i = this, s = qe(t) ? t : new H(t, e, n);
    return O(function() {
      var o = i, a = o.operator, u = o.source;
      s.add(a ? a.call(s, u) : u ? i._subscribe(s) : i._trySubscribe(s));
    }), s;
  }, r.prototype._trySubscribe = function(t) {
    try {
      return this._subscribe(t);
    } catch (e) {
      t.error(e);
    }
  }, r.prototype.forEach = function(t, e) {
    var n = this;
    return e = z(e), new e(function(i, s) {
      var o = new H({
        next: function(a) {
          try {
            t(a);
          } catch (u) {
            s(u), o.unsubscribe();
          }
        },
        error: s,
        complete: i
      });
      n.subscribe(o);
    });
  }, r.prototype._subscribe = function(t) {
    var e;
    return (e = this.source) === null || e === void 0 ? void 0 : e.subscribe(t);
  }, r.prototype[Y] = function() {
    return this;
  }, r.prototype.pipe = function() {
    for (var t = [], e = 0; e < arguments.length; e++)
      t[e] = arguments[e];
    return ke(t)(this);
  }, r.prototype.toPromise = function(t) {
    var e = this;
    return t = z(t), new t(function(n, i) {
      var s;
      e.subscribe(function(o) {
        return s = o;
      }, function(o) {
        return i(o);
      }, function() {
        return n(s);
      });
    });
  }, r.create = function(t) {
    return new r(t);
  }, r;
}();
function z(r) {
  var t;
  return (t = r ?? ce.Promise) !== null && t !== void 0 ? t : Promise;
}
function De(r) {
  return r && d(r.next) && d(r.error) && d(r.complete);
}
function qe(r) {
  return r && r instanceof N || De(r) && ue(r);
}
function je(r) {
  return d(r[Y]);
}
function $e(r) {
  return Symbol.asyncIterator && d(r == null ? void 0 : r[Symbol.asyncIterator]);
}
function Le(r) {
  return new TypeError("You provided " + (r !== null && typeof r == "object" ? "an invalid object" : "'" + r + "'") + " where a stream was expected. You can provide an Observable, Promise, ReadableStream, Array, AsyncIterable, or Iterable.");
}
function Ue() {
  return typeof Symbol != "function" || !Symbol.iterator ? "@@iterator" : Symbol.iterator;
}
var He = Ue();
function Be(r) {
  return d(r == null ? void 0 : r[He]);
}
function Fe(r) {
  return Ae(this, arguments, function() {
    var e, n, i, s;
    return se(this, function(o) {
      switch (o.label) {
        case 0:
          e = r.getReader(), o.label = 1;
        case 1:
          o.trys.push([1, , 9, 10]), o.label = 2;
        case 2:
          return [4, R(e.read())];
        case 3:
          return n = o.sent(), i = n.value, s = n.done, s ? [4, R(void 0)] : [3, 5];
        case 4:
          return [2, o.sent()];
        case 5:
          return [4, R(i)];
        case 6:
          return [4, o.sent()];
        case 7:
          return o.sent(), [3, 2];
        case 8:
          return [3, 10];
        case 9:
          return e.releaseLock(), [7];
        case 10:
          return [2];
      }
    });
  });
}
function Ve(r) {
  return d(r == null ? void 0 : r.getReader);
}
function he(r) {
  if (r instanceof m)
    return r;
  if (r != null) {
    if (je(r))
      return Ne(r);
    if (xe(r))
      return Ye(r);
    if (_e(r))
      return Ke(r);
    if ($e(r))
      return fe(r);
    if (Be(r))
      return Ge(r);
    if (Ve(r))
      return We(r);
  }
  throw Le(r);
}
function Ne(r) {
  return new m(function(t) {
    var e = r[Y]();
    if (d(e.subscribe))
      return e.subscribe(t);
    throw new TypeError("Provided object does not correctly implement Symbol.observable");
  });
}
function Ye(r) {
  return new m(function(t) {
    for (var e = 0; e < r.length && !t.closed; e++)
      t.next(r[e]);
    t.complete();
  });
}
function Ke(r) {
  return new m(function(t) {
    r.then(function(e) {
      t.closed || (t.next(e), t.complete());
    }, function(e) {
      return t.error(e);
    }).then(null, le);
  });
}
function Ge(r) {
  return new m(function(t) {
    var e, n;
    try {
      for (var i = A(r), s = i.next(); !s.done; s = i.next()) {
        var o = s.value;
        if (t.next(o), t.closed)
          return;
      }
    } catch (a) {
      e = { error: a };
    } finally {
      try {
        s && !s.done && (n = i.return) && n.call(i);
      } finally {
        if (e)
          throw e.error;
      }
    }
    t.complete();
  });
}
function fe(r) {
  return new m(function(t) {
    Qe(r, t).catch(function(e) {
      return t.error(e);
    });
  });
}
function We(r) {
  return fe(Fe(r));
}
function Qe(r, t) {
  var e, n, i, s;
  return Re(this, void 0, void 0, function() {
    var o, a;
    return se(this, function(u) {
      switch (u.label) {
        case 0:
          u.trys.push([0, 5, 6, 11]), e = Ie(r), u.label = 1;
        case 1:
          return [4, e.next()];
        case 2:
          if (n = u.sent(), !!n.done)
            return [3, 4];
          if (o = n.value, t.next(o), t.closed)
            return [2];
          u.label = 3;
        case 3:
          return [3, 1];
        case 4:
          return [3, 11];
        case 5:
          return a = u.sent(), i = { error: a }, [3, 11];
        case 6:
          return u.trys.push([6, , 9, 10]), n && !n.done && (s = e.return) ? [4, s.call(e)] : [3, 8];
        case 7:
          u.sent(), u.label = 8;
        case 8:
          return [3, 10];
        case 9:
          if (i)
            throw i.error;
          return [7];
        case 10:
          return [7];
        case 11:
          return t.complete(), [2];
      }
    });
  });
}
function T(r, t, e, n, i) {
  return new ze(r, t, e, n, i);
}
var ze = function(r) {
  w(t, r);
  function t(e, n, i, s, o, a) {
    var u = r.call(this, e) || this;
    return u.onFinalize = o, u.shouldUnsubscribe = a, u._next = n ? function(c) {
      try {
        n(c);
      } catch (l) {
        e.error(l);
      }
    } : r.prototype._next, u._error = s ? function(c) {
      try {
        s(c);
      } catch (l) {
        e.error(l);
      } finally {
        this.unsubscribe();
      }
    } : r.prototype._error, u._complete = i ? function() {
      try {
        i();
      } catch (c) {
        e.error(c);
      } finally {
        this.unsubscribe();
      }
    } : r.prototype._complete, u;
  }
  return t.prototype.unsubscribe = function() {
    var e;
    if (!this.shouldUnsubscribe || this.shouldUnsubscribe()) {
      var n = this.closed;
      r.prototype.unsubscribe.call(this), !n && ((e = this.onFinalize) === null || e === void 0 || e.call(this));
    }
  }, t;
}(N), Je = function(r) {
  w(t, r);
  function t(e, n) {
    return r.call(this) || this;
  }
  return t.prototype.schedule = function(e, n) {
    return this;
  }, t;
}(P), D = {
  setInterval: function(r, t) {
    for (var e = [], n = 2; n < arguments.length; n++)
      e[n - 2] = arguments[n];
    var i = D.delegate;
    return i != null && i.setInterval ? i.setInterval.apply(i, x([r, t], I(e))) : setInterval.apply(void 0, x([r, t], I(e)));
  },
  clearInterval: function(r) {
    var t = D.delegate;
    return ((t == null ? void 0 : t.clearInterval) || clearInterval)(r);
  },
  delegate: void 0
}, Xe = function(r) {
  w(t, r);
  function t(e, n) {
    var i = r.call(this, e, n) || this;
    return i.scheduler = e, i.work = n, i.pending = !1, i;
  }
  return t.prototype.schedule = function(e, n) {
    var i;
    if (n === void 0 && (n = 0), this.closed)
      return this;
    this.state = e;
    var s = this.id, o = this.scheduler;
    return s != null && (this.id = this.recycleAsyncId(o, s, n)), this.pending = !0, this.delay = n, this.id = (i = this.id) !== null && i !== void 0 ? i : this.requestAsyncId(o, this.id, n), this;
  }, t.prototype.requestAsyncId = function(e, n, i) {
    return i === void 0 && (i = 0), D.setInterval(e.flush.bind(e, this), i);
  }, t.prototype.recycleAsyncId = function(e, n, i) {
    if (i === void 0 && (i = 0), i != null && this.delay === i && this.pending === !1)
      return n;
    n != null && D.clearInterval(n);
  }, t.prototype.execute = function(e, n) {
    if (this.closed)
      return new Error("executing a cancelled action");
    this.pending = !1;
    var i = this._execute(e, n);
    if (i)
      return i;
    this.pending === !1 && this.id != null && (this.id = this.recycleAsyncId(this.scheduler, this.id, null));
  }, t.prototype._execute = function(e, n) {
    var i = !1, s;
    try {
      this.work(e);
    } catch (o) {
      i = !0, s = o || new Error("Scheduled action threw falsy error");
    }
    if (i)
      return this.unsubscribe(), s;
  }, t.prototype.unsubscribe = function() {
    if (!this.closed) {
      var e = this, n = e.id, i = e.scheduler, s = i.actions;
      this.work = this.state = this.scheduler = null, this.pending = !1, k(s, this), n != null && (this.id = this.recycleAsyncId(i, n, null)), this.delay = null, r.prototype.unsubscribe.call(this);
    }
  }, t;
}(Je), pe = {
  now: function() {
    return (pe.delegate || Date).now();
  },
  delegate: void 0
}, J = function() {
  function r(t, e) {
    e === void 0 && (e = r.now), this.schedulerActionCtor = t, this.now = e;
  }
  return r.prototype.schedule = function(t, e, n) {
    return e === void 0 && (e = 0), new this.schedulerActionCtor(this, t).schedule(n, e);
  }, r.now = pe.now, r;
}(), Ze = function(r) {
  w(t, r);
  function t(e, n) {
    n === void 0 && (n = J.now);
    var i = r.call(this, e, n) || this;
    return i.actions = [], i._active = !1, i;
  }
  return t.prototype.flush = function(e) {
    var n = this.actions;
    if (this._active) {
      n.push(e);
      return;
    }
    var i;
    this._active = !0;
    do
      if (i = e.execute(e.state, e.delay))
        break;
    while (e = n.shift());
    if (this._active = !1, i) {
      for (; e = n.shift(); )
        e.unsubscribe();
      throw i;
    }
  }, t;
}(J), K = new Ze(Xe), et = K;
function tt(r) {
  return r && d(r.schedule);
}
function rt(r) {
  return r instanceof Date && !isNaN(r);
}
function nt(r, t, e) {
  r === void 0 && (r = 0), e === void 0 && (e = et);
  var n = -1;
  return t != null && (tt(t) ? e = t : n = t), new m(function(i) {
    var s = rt(r) ? +r - e.now() : r;
    s < 0 && (s = 0);
    var o = 0;
    return e.schedule(function() {
      i.closed || (i.next(o++), 0 <= n ? this.schedule(void 0, n) : i.complete());
    }, s);
  });
}
function it(r, t, e, n, i) {
  n === void 0 && (n = 0), i === void 0 && (i = !1);
  var s = t.schedule(function() {
    e(), i ? r.add(this.schedule(null, n)) : this.unsubscribe();
  }, n);
  if (r.add(s), !i)
    return s;
}
function B(r, t) {
  return q(function(e, n) {
    var i = 0;
    e.subscribe(T(n, function(s) {
      n.next(r.call(t, s, i++));
    }));
  });
}
function st(r, t, e, n, i, s, o, a) {
  var u = [], c = 0, l = 0, y = !1, f = function() {
    y && !u.length && !c && t.complete();
  }, v = function(p) {
    return c < n ? b(p) : u.push(p);
  }, b = function(p) {
    s && t.next(p), c++;
    var G = !1;
    he(e(p, l++)).subscribe(T(t, function(_) {
      i == null || i(_), s ? v(_) : t.next(_);
    }, function() {
      G = !0;
    }, void 0, function() {
      if (G)
        try {
          c--;
          for (var _ = function() {
            var M = u.shift();
            o ? it(t, o, function() {
              return b(M);
            }) : b(M);
          }; u.length && c < n; )
            _();
          f();
        } catch (M) {
          t.error(M);
        }
    }));
  };
  return r.subscribe(T(t, v, function() {
    y = !0, f();
  })), function() {
    a == null || a();
  };
}
function F(r, t, e) {
  return e === void 0 && (e = 1 / 0), d(t) ? F(function(n, i) {
    return B(function(s, o) {
      return t(n, s, i, o);
    })(he(r(n, i)));
  }, e) : (typeof t == "number" && (e = t), q(function(n, i) {
    return st(n, i, r, e);
  }));
}
var ot = oe(function(r) {
  return function() {
    r(this), this.name = "ObjectUnsubscribedError", this.message = "object unsubscribed";
  };
}), S = function(r) {
  w(t, r);
  function t() {
    var e = r.call(this) || this;
    return e.closed = !1, e.currentObservers = null, e.observers = [], e.isStopped = !1, e.hasError = !1, e.thrownError = null, e;
  }
  return t.prototype.lift = function(e) {
    var n = new X(this, this);
    return n.operator = e, n;
  }, t.prototype._throwIfClosed = function() {
    if (this.closed)
      throw new ot();
  }, t.prototype.next = function(e) {
    var n = this;
    O(function() {
      var i, s;
      if (n._throwIfClosed(), !n.isStopped) {
        n.currentObservers || (n.currentObservers = Array.from(n.observers));
        try {
          for (var o = A(n.currentObservers), a = o.next(); !a.done; a = o.next()) {
            var u = a.value;
            u.next(e);
          }
        } catch (c) {
          i = { error: c };
        } finally {
          try {
            a && !a.done && (s = o.return) && s.call(o);
          } finally {
            if (i)
              throw i.error;
          }
        }
      }
    });
  }, t.prototype.error = function(e) {
    var n = this;
    O(function() {
      if (n._throwIfClosed(), !n.isStopped) {
        n.hasError = n.isStopped = !0, n.thrownError = e;
        for (var i = n.observers; i.length; )
          i.shift().error(e);
      }
    });
  }, t.prototype.complete = function() {
    var e = this;
    O(function() {
      if (e._throwIfClosed(), !e.isStopped) {
        e.isStopped = !0;
        for (var n = e.observers; n.length; )
          n.shift().complete();
      }
    });
  }, t.prototype.unsubscribe = function() {
    this.isStopped = this.closed = !0, this.observers = this.currentObservers = null;
  }, Object.defineProperty(t.prototype, "observed", {
    get: function() {
      var e;
      return ((e = this.observers) === null || e === void 0 ? void 0 : e.length) > 0;
    },
    enumerable: !1,
    configurable: !0
  }), t.prototype._trySubscribe = function(e) {
    return this._throwIfClosed(), r.prototype._trySubscribe.call(this, e);
  }, t.prototype._subscribe = function(e) {
    return this._throwIfClosed(), this._checkFinalizedStatuses(e), this._innerSubscribe(e);
  }, t.prototype._innerSubscribe = function(e) {
    var n = this, i = this, s = i.hasError, o = i.isStopped, a = i.observers;
    return s || o ? ae : (this.currentObservers = null, a.push(e), new P(function() {
      n.currentObservers = null, k(a, e);
    }));
  }, t.prototype._checkFinalizedStatuses = function(e) {
    var n = this, i = n.hasError, s = n.thrownError, o = n.isStopped;
    i ? e.error(s) : o && e.complete();
  }, t.prototype.asObservable = function() {
    var e = new m();
    return e.source = this, e;
  }, t.create = function(e, n) {
    return new X(e, n);
  }, t;
}(m), X = function(r) {
  w(t, r);
  function t(e, n) {
    var i = r.call(this) || this;
    return i.destination = e, i.source = n, i;
  }
  return t.prototype.next = function(e) {
    var n, i;
    (i = (n = this.destination) === null || n === void 0 ? void 0 : n.next) === null || i === void 0 || i.call(n, e);
  }, t.prototype.error = function(e) {
    var n, i;
    (i = (n = this.destination) === null || n === void 0 ? void 0 : n.error) === null || i === void 0 || i.call(n, e);
  }, t.prototype.complete = function() {
    var e, n;
    (n = (e = this.destination) === null || e === void 0 ? void 0 : e.complete) === null || n === void 0 || n.call(e);
  }, t.prototype._subscribe = function(e) {
    var n, i;
    return (i = (n = this.source) === null || n === void 0 ? void 0 : n.subscribe(e)) !== null && i !== void 0 ? i : ae;
  }, t;
}(S);
function de(r, t) {
  return t === void 0 && (t = K), q(function(e, n) {
    var i = null, s = null, o = null, a = function() {
      if (i) {
        i.unsubscribe(), i = null;
        var c = s;
        s = null, n.next(c);
      }
    };
    function u() {
      var c = o + r, l = t.now();
      if (l < c) {
        i = this.schedule(void 0, c - l), n.add(i);
        return;
      }
      a();
    }
    e.subscribe(T(n, function(c) {
      s = c, o = t.now(), i || (i = t.schedule(u, r), n.add(i));
    }, function() {
      a(), n.complete();
    }, void 0, function() {
      s = i = null;
    }));
  });
}
function Z(r, t) {
  return q(function(e, n) {
    var i = 0;
    e.subscribe(T(n, function(s) {
      return r.call(t, s, i++) && n.next(s);
    }));
  });
}
function at(r, t) {
  return r === void 0 && (r = 0), t === void 0 && (t = K), r < 0 && (r = 0), nt(r, r, t);
}
function ee() {
  return new ie(g);
}
class ut extends Error {
  constructor(t) {
    super(), Error.captureStackTrace(this, this.constructor), this.message = t;
  }
}
var te;
(function(r) {
  r.SYSTEM = "SYSTEM", r.CUSTOM = "CUSTOM", r.INTERNAL = "INTERNAL";
})(te || (te = {}));
var E;
(function(r) {
  r.USER_ADMIN = "USER-ADMIN", r.EDITOR = "EDITOR", r.VIEWER = "VIEWER", r.DYNAMIC_FIELD_DEF_ADMIN = "DYNAMIC-FIELD-DEF-ADMIN", r.SNIPPET_ADMIN = "SNIPPET-ADMIN";
})(E || (E = {}));
E.USER_ADMIN, E.EDITOR, E.VIEWER, E.DYNAMIC_FIELD_DEF_ADMIN, E.SNIPPET_ADMIN;
var V;
(function(r) {
  r.DEFAULT_USER = "DEFAULT-USER";
})(V || (V = {}));
V.DEFAULT_USER;
var re;
(function(r) {
  r.ACTIVE = "ACTIVE", r.INACTIVE = "INACTIVE";
})(re || (re = {}));
class ct {
  constructor(t, e = 20, n = 50) {
    h(this, "pendingRequests", []);
    h(this, "pendingResponsesByHashedRequest", /* @__PURE__ */ new Map());
    h(this, "pendingResponseResolversByHashedRequest", /* @__PURE__ */ new Map());
    h(this, "request$", new S());
    this.collatedApi = t, this.debounce = e, this.maximumEntitiesPerRequest = n, this.request$.pipe(de(e)).subscribe(this.collatedRequest.bind(this));
  }
  get(t) {
    const e = g(t);
    if (this.pendingResponsesByHashedRequest.has(e))
      return this.pendingResponsesByHashedRequest.get(e);
    const n = new Promise((i, s) => {
      this.pendingResponseResolversByHashedRequest.set(e, { resolve: i, reject: s });
    });
    return this.pendingResponsesByHashedRequest.set(e, n), this.pendingRequests.push(t), this.request$.next(), n;
  }
  /**
   * Perform a collated request, combining up to 50 pending requests into a single
   * API request using the passed collatedApi implementation.
   * On response, notify each bound request of the response.
   * @private
   */
  collatedRequest() {
    const t = this.pendingRequests.slice(
      0,
      this.maximumEntitiesPerRequest
    );
    t.length !== 0 && (this.pendingRequests = this.pendingRequests.slice(t.length), this.pendingRequests.length && this.request$.next(), this.collatedApi.call(this, t).then((e) => {
      this.processSuccessfulResponse(t, e);
    }).catch((e) => {
      this.processErrorResponse(t, e);
    }));
  }
  /**
   * Process a response payload and notify individual query consumers of either the response payload
   * or a missing response.
   *
   * @param currentRequests   The active requests
   * @param results           The response map
   * @private
   */
  processSuccessfulResponse(t, e) {
    const n = t.reduce((i, s) => (i.set(g(s), s), i), /* @__PURE__ */ new Map());
    e.forEach((i, s) => {
      const o = g(s);
      n.delete(o);
      const a = this.pendingResponseResolversByHashedRequest.get(o);
      a != null && (a.resolve(i), this.pendingResponseResolversByHashedRequest.delete(o), this.pendingResponsesByHashedRequest.delete(o));
    }), n.forEach((i, s) => {
      const o = this.pendingResponseResolversByHashedRequest.get(s);
      o != null && o.reject(new ut("Not found"));
    });
  }
  /**
   * Process an API error response and notify all active consumers of an error
   * fetching their data.
   *
   * @param currentRequests   The active requests
   * @param error             The API error
   * @private
   */
  processErrorResponse(t, e) {
    t.forEach((n) => {
      const i = g(n), s = this.pendingResponseResolversByHashedRequest.get(i);
      s != null && s.reject(e);
    });
  }
}
function wt(r) {
  return new ve(r);
}
class ve {
  constructor(t) {
    this.options = t;
  }
  list(t, e, n = []) {
    const i = ee(), s = new Set(n);
    return this.options.service.eventsBeforePublish.pipe(
      B(
        (o) => o.filter(
          (a) => t == null || t == a.type || s.has(a.type)
        )
      ),
      Z((o) => o.length > 0),
      F((o) => o)
    ).subscribe((o) => {
      (t == null || t === o.type || s.has(o.type)) && i.clear();
    }), this.options.service.stopped.subscribe(() => {
      i.clear();
    }), (o) => {
      const a = o;
      if (i.has(a))
        return i.get(a);
      const u = o != null ? this.addRevisionParameter(o) : o, c = e(u).catch((l) => (i.delete(a), Promise.reject(l)));
      return i.set(a, c), c;
    };
  }
  get(t, e, n = []) {
    const i = /* @__PURE__ */ new Map(), s = new Set(n);
    return this.options.service.eventsBeforePublish.subscribe((o) => {
      for (const a of o)
        if (t == null || t === a.type) {
          const u = a.id;
          i.delete(u);
        } else if (s.has(a.type)) {
          i.clear();
          break;
        }
    }), this.options.service.stopped.subscribe(() => {
      i.clear();
    }), (o) => {
      const a = o.id;
      if (i.has(a))
        return i.get(a);
      const u = this.addRevisionParameter(o), c = e(u).catch((l) => (i.delete(a), Promise.reject(l)));
      return i.set(a, c), c;
    };
  }
  getSingleton(t, e, n = []) {
    const i = /* @__PURE__ */ new Map(), s = new Set(n);
    return this.options.service.eventsBeforePublish.subscribe((o) => {
      for (const a of o)
        if (t == null || t === a.type) {
          const u = a.id;
          i.delete(u);
        } else if (s.has(a.type)) {
          i.clear();
          break;
        }
    }), this.options.service.stopped.subscribe(() => {
      i.clear();
    }), (o) => {
      const a = o.id;
      if (i.has(a))
        return i.get(a);
      const u = this.addRevisionParameter(o), c = e(u).catch((l) => (i.delete(a), Promise.reject(l)));
      return i.set(a, c), c;
    };
  }
  /**
   * Creates caching get method that aggregates singular get requests into one request
   *
   * @param entityType The entity type used to filter down to relevant events.
   *  If null, the cache will be invalidated when any event happens
   * @param list The list method
   * @param toPathParameters The entity path parameter function
   * @param debounce The debounce time (@default 20)
   */
  batchingGet(t, e, n, i = 20) {
    const s = ee(), o = new ct(
      (a) => e({
        ...n(a[0]),
        ids: a.map((u) => u.id).join(",")
      }).then(
        (u) => u.reduce((c, l) => (c.set(
          {
            // hacky/presumptive about API pattern
            ...a[0],
            id: l.id
          },
          l
        ), c), /* @__PURE__ */ new Map())
      ),
      i
    );
    return this.options.service.stopped.subscribe(() => {
      s.clear();
    }), this.options.service.eventsBeforePublish.pipe(
      B((a) => t != null ? a.filter((u) => u.type === t) : a),
      Z((a) => a.length > 0),
      F((a) => a)
    ).subscribe((a) => {
      s.clear();
    }), (a) => {
      const u = a;
      if (s.has(u))
        return s.get(u);
      const c = this.addRevisionParameter(a), l = o.get(c).catch((y) => (s.delete(u), Promise.reject(y)));
      return s.set(u, l), l;
    };
  }
  /**
   * @deprecated use {@link #entityAwaitingMutation}
   */
  create(t) {
    return this.entityAwaitingMutation(t);
  }
  /**
   * @deprecated use {@link #revisionedEntityAwaitingMutation}
   */
  update(t) {
    return this.revisionedEntityAwaitingMutation(t);
  }
  /**
   * @deprecated use {@link #revisionedEntityAwaitingMutation}
   */
  delete(t) {
    return this.revisionedEntityAwaitingMutation(t);
  }
  /**
   * @deprecated use {@link #entityAwaitingMutation}
   */
  clone(t) {
    return this.entityAwaitingMutation(t);
  }
  entityAwaitingMutation(t) {
    return async (...e) => {
      await this.options.service.pause();
      let n;
      try {
        n = await t(...e);
      } finally {
        this.options.service.unpause();
      }
      return { id: n.id };
    };
  }
  revisionedEntityAwaitingMutation(t) {
    return async (e) => {
      await this.options.service.pause();
      let n;
      try {
        n = await t(e);
      } finally {
        this.options.service.unpause();
      }
      return {
        id: e.id,
        revision: n.revision
      };
    };
  }
  revisionAwaitingMutation(t) {
    return async (...e) => {
      var s, o, a;
      await this.options.service.pause();
      let n;
      try {
        n = await t(...e);
      } finally {
        this.options.service.unpause();
      }
      const [i] = e;
      if (i != null && typeof i == "object") {
        const u = (o = (s = this.options).scope) == null ? void 0 : o.call(s, i);
        if (u != null) {
          const c = (a = this.options.service.latestRevisionCache) == null ? void 0 : a.getLatestRevision(u);
          if (c != null && c >= n.revision)
            return;
        }
      }
    };
  }
  mutation(t) {
    return async (...e) => {
      await this.options.service.pause();
      let n;
      try {
        n = await t(...e);
      } finally {
        this.options.service.unpause();
      }
      return {
        id: n.id
      };
    };
  }
  addRevisionParameter(t) {
    var i, s, o;
    const e = (s = (i = this.options).scope) == null ? void 0 : s.call(i, t);
    if (e == null)
      return t;
    const n = (o = this.options.service.latestRevisionCache) == null ? void 0 : o.getLatestRevision(e);
    return n != null ? { ...t, revision: n } : t;
  }
}
h(ve, "defaults", {
  timeout: 30 * 1e3
});
class St extends ne {
  /**
   * @param client The client used to retrieve the entity data
   */
  constructor(t) {
    super({
      ...t,
      list: ge(t.list)
    }), this.client = t;
  }
}
class Et {
  /**
   * @param client The client used to retrieve the options data
   */
  constructor(t) {
    h(this, "getOptions");
    this.client = t, this.getOptions = this.client.getOptions;
  }
}
function Rt() {
  return new lt();
}
class lt {
  /**
   * Creates a list method for a static readonly entity
   * @param list The delegate client method used to fetch the data
   */
  list(t) {
    const e = {};
    return (n) => (e.value == null && (e.value = t(n)), e.value);
  }
  /**
   * Creates a get method for a static readonly entity
   * @param get The delegate client method used to fetch the data
   */
  get(t) {
    const e = {};
    return (n) => (e[n.id] == null && (e[n.id] = t(n)), e[n.id]);
  }
}
class At {
  constructor(t) {
    h(this, "cache", /* @__PURE__ */ new Map());
    this.getLatestScopeRevision = t;
  }
  async get(t) {
    const e = this.cache.get(t);
    if ((e == null ? void 0 : e.value) != null)
      return e.value;
    if ((e == null ? void 0 : e.promise) != null)
      return await e.promise;
    const n = this.getLatestScopeRevision(t);
    return this.cache.set(t, { promise: n }), n;
  }
  setIfLatest(t, e) {
    const n = this.cache.get(t);
    n != null && (n.value == null || e > n.value) && (n.value = e);
  }
  clear() {
    this.cache.clear();
  }
  getLatestRevision(t) {
    const e = this.cache.get(t);
    return e == null ? void 0 : e.value;
  }
}
function ht(r) {
  return r && r.__esModule && Object.prototype.hasOwnProperty.call(r, "default") ? r.default : r;
}
var ye = { exports: {} };
(function(r, t) {
  (function(e) {
    var n = function(s) {
      setTimeout(s, 0);
    };
    typeof process < "u" && process && typeof process.nextTick == "function" && (n = process.nextTick);
    function i(s) {
      var o = {
        capacity: s || 1,
        current: 0,
        queue: [],
        firstHere: !1,
        take: function() {
          if (o.firstHere === !1) {
            o.current++, o.firstHere = !0;
            var a = 1;
          } else
            var a = 0;
          var u = { n: 1 };
          typeof arguments[0] == "function" ? u.task = arguments[0] : u.n = arguments[0], arguments.length >= 2 && (typeof arguments[1] == "function" ? u.task = arguments[1] : u.n = arguments[1]);
          var c = u.task;
          if (u.task = function() {
            c(o.leave);
          }, o.current + u.n - a > o.capacity)
            return a === 1 && (o.current--, o.firstHere = !1), o.queue.push(u);
          o.current += u.n - a, u.task(o.leave), a === 1 && (o.firstHere = !1);
        },
        leave: function(a) {
          if (a = a || 1, o.current -= a, !o.queue.length) {
            if (o.current < 0)
              throw new Error("leave called too many times.");
            return;
          }
          var u = o.queue[0];
          u.n + o.current > o.capacity || (o.queue.shift(), o.current += u.n, n(u.task));
        },
        available: function(a) {
          return a = a || 1, o.current + a <= o.capacity;
        }
      };
      return o;
    }
    r.exports = i;
  })();
})(ye);
var ft = ye.exports;
const pt = /* @__PURE__ */ ht(ft), dt = {
  pollingInterval: 5e3,
  refreshRequestDebounce: 10,
  pauseAlarmTimeout: 35 * 1e3
};
class It {
  constructor(t) {
    h(this, "pauseTokenCount", 100);
    h(this, "pauseAlarmTimeoutId", null);
    h(this, "pauseSemaphore", pt(this.pauseTokenCount));
    h(this, "lastRequestTime");
    h(this, "refreshRequests$", new S());
    h(this, "eventsBeforePublish$", new S());
    h(this, "events$", new S());
    h(this, "errors$", new S());
    h(this, "stopped$", new S());
    h(this, "settings");
    h(this, "subscription");
    h(this, "eventsBeforePublish", this.eventsBeforePublish$.asObservable());
    h(this, "events", this.events$.asObservable());
    h(this, "errors", this.errors$.asObservable());
    h(this, "stopped", this.stopped$.asObservable());
    this.settings = { ...dt, ...t }, this.lastRequestTime = new Date((/* @__PURE__ */ new Date()).getTime() - this.settings.pollingInterval), this.refreshRequests$.pipe(de(this.settings.refreshRequestDebounce)).subscribe(() => {
      this.pollChangeEvents();
    });
  }
  get latestRevisionCache() {
    return this.settings.latestRevisionCache;
  }
  start() {
    this.subscription == null && (this.subscription = at(this.settings.pollingInterval).subscribe(() => {
      this.refresh();
    }));
  }
  stop() {
    var t, e;
    (t = this.subscription) == null || t.unsubscribe(), this.subscription = void 0, this.stopped$.next(), (e = this.settings.latestRevisionCache) == null || e.clear();
  }
  refresh() {
    this.refreshRequests$.next();
  }
  destroy() {
    this.eventsBeforePublish$.complete(), this.events$.complete(), this.errors$.complete(), this.refreshRequests$.complete(), this.stop(), this.stopped$.complete();
  }
  async pollChangeEvents() {
    var t;
    if (this.pauseSemaphore.available(this.pauseSemaphore.capacity)) {
      await this.pauseTake(this.pauseSemaphore.capacity);
      try {
        const { timestamp: e, changeEvents: n } = await this.settings.fetch(this.lastRequestTime);
        if (this.lastRequestTime = new Date(e), n.length > 0) {
          for (const i of n) {
            const { scope: s, revision: o } = i;
            (t = this.latestRevisionCache) == null || t.setIfLatest(s, o);
          }
          this.eventsBeforePublish$.next(n), this.events$.next(n);
        }
      } catch (e) {
        this.errors$.next(e);
      } finally {
        this.pauseSemaphore.leave(this.pauseSemaphore.current);
      }
    }
  }
  async pause() {
    await this.pauseTake(1), this.pauseSemaphore.available(this.pauseSemaphore.capacity - 1) && (this.pauseAlarmTimeoutId = setTimeout(() => {
      console.warn(
        `Events paused for too long with [${this.pauseSemaphore.current}] outstanding pauses. Forcing an unpause.`
      ), this.pauseSemaphore.leave(this.pauseSemaphore.current), this.refresh();
    }, this.settings.pauseAlarmTimeout));
  }
  unpause() {
    this.pauseSemaphore.available(this.pauseSemaphore.capacity) || this.pauseSemaphore.leave(1), this.pauseSemaphore.available(this.pauseSemaphore.capacity) && (this.pauseAlarmTimeoutId != null && clearTimeout(this.pauseAlarmTimeoutId), this.refresh());
  }
  pauseTake(t) {
    return new Promise((e, n) => {
      try {
        this.pauseSemaphore.take(t, () => e());
      } catch (i) {
        n(i);
      }
    });
  }
}
export {
  ne as AbstractListableEntityService,
  bt as AbstractReadableEntityService,
  we as AbstractRealtimeListableEntityService,
  Se as AbstractRealtimeReadableEntityService,
  gt as AbstractRealtimeWritableEntityService,
  St as AbstractStaticListableEntityService,
  Et as AbstractStaticOptionService,
  mt as CodedError,
  At as DefaultLatestRevisionCache,
  It as PollingChangeEventService,
  ve as RealtimeServiceFactory,
  lt as StaticServiceFactory,
  ge as caching,
  g as hashObject,
  wt as realtime,
  Rt as staticServiceFactory
};
//# sourceMappingURL=index.mjs.map
